import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex gap-x-2 justify-center mt-12" }

import PaginationButton from './PaginationButton.vue';
import { ref, computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ListPagination',
  props: {
    totalPages: {},
    currentPage: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const visiblePages = computed(() => {
  const currentPage = Math.max(1, Math.min(props.currentPage, props.totalPages));

  let start = Math.max(1, currentPage - 2);
  let end = Math.min(props.totalPages, currentPage + 2);

  if (end - start + 1 < 5) {
    if (start === 1) {
      end = Math.min(props.totalPages, start + 4);
    } else if (end === props.totalPages) {
      start = Math.max(1, end - 4);
    }
  }

  const pageIndices = [];
  for (let i = start; i <= end; i++) {
    pageIndices.push(i);
  }

  return pageIndices;
})

function setCurrentPage(value: number) {
  emit('change', value)
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PaginationButton, {
      "is-disabled": _ctx.currentPage == 1,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setCurrentPage(_ctx.currentPage - 1)))
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "text-lg material-symbols-outlined" }, "arrow_back", -1)
      ])),
      _: 1
    }, 8, ["is-disabled"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (index) => {
      return (_openBlock(), _createBlock(PaginationButton, {
        key: index,
        "is-current": _ctx.currentPage === index,
        onClick: ($event: any) => (setCurrentPage(index))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(index), 1)
        ]),
        _: 2
      }, 1032, ["is-current", "onClick"]))
    }), 128)),
    _createVNode(PaginationButton, {
      "is-disabled": _ctx.currentPage == _ctx.totalPages,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setCurrentPage(_ctx.currentPage + 1)))
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("span", { class: "text-lg material-symbols-outlined" }, "arrow_forward", -1)
      ])),
      _: 1
    }, 8, ["is-disabled"])
  ], 512)), [
    [_vShow, _ctx.totalPages > 1]
  ])
}
}

})